import * as React from "react"
import { List } from "immutable"
import { ActivitySummary, ActivitySummaryProps } from "../components/activity_summary"
import { noResultsText } from "../../custom_api/api"
import { trackActivityClick as trackClusterActivityClick } from "./library/tracking"

export interface ActivityClusterProps {
  readonly title?: string
  readonly description?: string
  readonly slug: string
  readonly activitySummaries: List<ActivitySummaryProps>
}

export const ActivityCluster = (p: ActivityClusterProps & { row_count: number } ): JSX.Element => (
  <section className="block block--activity-cluster" data-anchor={p.slug}>
    <header className="block__header">
      {p.title && <h3 className="block__title title--l">{p.title}</h3>}
      {p.description && <p className="block__intro">{p.description}</p>}
    </header>

    <ul className="row teasers">
      {p.activitySummaries.isEmpty()
        ? noResultsText
        : p.activitySummaries.map((s, i) => (
          <ActivitySummary
            key={`activity-summary-${i}`}
            headingLevel="h3"
            title={s.title}
            date={s.date}
            imageAlt={s.imageAlt}
            imageUrl={s.imageUrl}
            subtitle={s.subtitle}
            location={s.location}
            route={s.route}
            row_count={p.row_count}
            onClick={() => trackClusterActivityClick(s.title, p.title)}
            isTip={s.isTip}
          />
        ))}
    </ul>
  </section>
)
